import { z } from "zod";

import Blockquote from "@/components/ui/chat/blockquote/Blockquote";

/** Chat catalog definition for Quote (Blockquote). Use in renderer catalog. */
export const ChatBlockquoteSpec = {
  props: z.object({
    /** Excerpt or key statement text. */
    content: z.string(),
    /** Speaker or name when known. */
    attribution: z.string().nullable().optional(),
    /** Publication or outlet when known. */
    source: z.string().nullable().optional(),
  }),
  description:
    "Styled blockquote for highlighting article excerpts, key statements, or notable quotes from coverage.",
  example: {
    content:
      "AI isn't here to replace how we work, it's here to remove the friction. The real advantage comes when teams spend less time on busywork and more time on the decisions that matter.",
    attribution: "Sophie Tan",
    source: "Forbes",
  },
} as const;

type BlockquotePropsFromSpec = {
  content: string;
  attribution?: string | null;
  source?: string | null;
};

/**
 * Adapter for json-render defineRegistry: renders Blockquote from catalog props.
 */
export const ChatBlockquoteFromProps = ({
  props,
}: {
  props: Record<string, unknown>;
}) => {
  const { content, attribution, source } = props as BlockquotePropsFromSpec;
  return (
    <Blockquote
      content={content}
      attribution={attribution ?? undefined}
      source={source ?? undefined}
    />
  );
};
